
const TicketRequest = {
  "gdsRefrenceID": "string",
  };
 

  export default TicketRequest;
  